import { useApiMessagesStore } from '@services/Communications/store'

import { useMailboxesModule } from './mailboxes'
import { useThreadsModule } from './threads'

// ***
// REQUESTS
// ***

export function useApiMessagesStoreRequest() {
  const store = useApiMessagesStore()

  return {
    store,
    ...useMailboxesModule(store),
    ...useThreadsModule(store),
  }
}
